import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cadastrar-frequencia-aluno',
  templateUrl: './cadastrar-frequencia-aluno.component.html',
  styleUrls: ['./cadastrar-frequencia-aluno.component.css']
})
export class CadastrarFrequenciaAlunoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
